const types = {
    CHANGE_DATE: 'CHANGE_DATE',
    CHANGE_DATE_RANGE: 'CHANGE_DATE_RANGE',
    CHANGE_RENDER_TYPE: 'CHANGE_RENDER_TYPE',
    CHANGE_USER_INFO: 'CHANGE_USER_INFO',
    CHANGE_PORTFOLIOS_DATA: 'CHANGE_PORTFOLIOS_DATA',
    CHANGE_CHOSEN_PORTFOLIO_DATA: 'CHANGE_CHOSEN_PORTFOLIO_DATA',
    CHANGE_TRADING_CHART_DATA: 'CHANGE_TRADING_CHART_DATA',
    CHANGE_TRADING_REPORT_DATA: 'CHANGE_TRADING_REPORT_DATA',
    TOGGLE_SIGNAL_TABLE_DIALOG:'TOGGLE_SIGNAL_TABLE_DIALOG',
    FORCE_UPLOAD_DISABLE_BUTTON: 'FORCE_UPLOAD_DISABLE_BUTTON',
    CHANGE_STATUS_INFO: 'CHANGE_STATUS_INFO',
    CHANGE_ORGANIZATION_USERS: 'CHANGE_ORGANIZATION_USERS',
    CHANGE_ORGANIZATION_DOCUMENTS: 'CHANGE_ORGANIZATION_DOCUMENTS',
    TOGGLE_EXPIRATION_ERROR:'TOGGLE_EXPIRATION_ERROR'
};
 
export default types;